/* CustomControl.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._1wyb1j6v{font-size:1rem}";
const _7 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const _6 = "._19it1pvm{border:solid 1px var(--ds-border,#091e4224)}";
const _5 = "._18s8pxbi{margin:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { components } from '@atlaskit/select';
import VisuallyHidden from '@atlaskit/visually-hidden';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _2 = "._n7zl1pvm{border-bottom:solid 1px var(--ds-border,#091e4224)}";
const _ = "._1yt41b66{padding:var(--ds-space-050,4px)}";
export const SearchBarControl = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41b66 _n7zl1pvm _ect418aq _1e0c1txw", __cmplp.className])
    }))]
  });
});

/**
 * Replaces the default Control component in React Select.
 * When the select is searchable, it shows a search bar.
 * Otherwise, it renders a search box but visually hides it. This is to retain keyboard accessibilty features
 * (focus, key navigation) in the select dropdown.
 */
if (process.env.NODE_ENV !== 'production') {
  SearchBarControl.displayName = 'SearchBarControl';
}
export const CustomControl = props => {
  return props.selectProps.isSearchable ? /*#__PURE__*/_jsx(SearchBarControl, _objectSpread(_objectSpread({
    ref: props.innerRef
  }, props.innerProps), {}, {
    children: props.children
  })) : /*#__PURE__*/_jsx(VisuallyHidden, {
    children: /*#__PURE__*/_jsx(components.Control, _objectSpread({}, props))
  });
};
export const SearchBarControlMobile = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _3, _4, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8pxbi _19it1pvm _2rko12b0 _ect418aq _1e0c1txw _1wyb1j6v", __cmplp.className])
    }))]
  });
});

/**
 * Replaces the default Control component in React Select.
 * When the select is searchable, it shows a search bar.
 * Otherwise, it renders a search box but visually hides it. This is to retain keyboard accessibilty features
 * (focus, key navigation) in the select dropdown.
 */
if (process.env.NODE_ENV !== 'production') {
  SearchBarControlMobile.displayName = 'SearchBarControlMobile';
}
export const CustomControlMobile = props => {
  return props.selectProps.isSearchable ? /*#__PURE__*/_jsx(SearchBarControlMobile, _objectSpread(_objectSpread({
    ref: props.innerRef
  }, props.innerProps), {}, {
    children: props.children
  })) : /*#__PURE__*/_jsx(VisuallyHidden, {
    children: /*#__PURE__*/_jsx(components.Control, _objectSpread({}, props))
  });
};